import styled from 'styled-components';

import colors from '@app/constants/colors';

export const PackageBase = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  border: 1px solid ${colors.FLAMENKO_LIGHT};
  border-radius: 20px;
  background-color: ${({ selected }) => (selected ? colors.INTERNATIONAL_ORANGE : colors.FLAMENKO_LIGHT)};
  width: auto;
  min-width: 250px;
  height: auto;
  min-height: 320px;
  margin: ${({ hasMargin }) => (hasMargin ? '20px' : '0')};
  padding: 20px 15px;
  transition: all 0.5s ease;
  animation: animateShowDown 0.5s ease;
  
  & button {
    opacity: ${({ selected }) => (selected ? 0 : 1)};
    visibility: ${({ selected }) => (selected ? 'hidden' : 'visible')};
    transition: all 0.1s ease;
  }
`;

export const PackageContainer = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: ${({ centered }) => (centered ? 'center' : 'flex-start')};
  align-items: center;
  width: 100%;
  padding: 10px;
  max-width: 820px;
  
  @media (max-width: 728px) {
    flex-direction: column;
  }  
`;
